import { toValue, unref, useNuxtApp, useFetch, useLazyFetch } from "#imports";
import { fillPath } from "./utils.mjs";
const interceptors = ["onRequest", "onResponse", "onRequestError", "onResponseError"];
const getOptions = (arg) => {
  const { $openFetch } = useNuxtApp();
  return typeof arg === "string" ? $openFetch[arg] : arg;
};
const combineInterceptors = (...args) => {
  return interceptors.filter((name) => args.some((options) => options[name])).reduce((acc, name) => ({
    ...acc,
    [name]: async (ctx) => {
      await Promise.all(args.map((options) => unref(options[name])?.(ctx)));
    }
  }), {});
};
export function createOpenFetchClient(arg) {
  return (url, { path, ...options } = {}) => {
    const sharedOptions = getOptions(arg);
    return $fetch(fillPath(url, path), {
      ...sharedOptions,
      ...options,
      ...combineInterceptors(options, sharedOptions)
    });
  };
}
export function createUseOpenFetchClient(arg) {
  return (url, { path, ...options } = {}, autoKey) => {
    const sharedOptions = getOptions(arg);
    return useFetch(() => fillPath(toValue(url), toValue(path)), {
      ...sharedOptions,
      key: autoKey,
      ...options,
      ...combineInterceptors(options, sharedOptions)
    });
  };
}
export function createUseLazyOpenFetchClient(arg) {
  return (url, { path, ...options } = {}, autoKey) => {
    const sharedOptions = getOptions(arg);
    return useLazyFetch(() => fillPath(toValue(url), toValue(path)), {
      ...sharedOptions,
      key: autoKey,
      ...options,
      ...combineInterceptors(options, sharedOptions)
    });
  };
}
